module.exports = __webpack_public_path__ + "static/gajets-3b9f734bbdd84e2ff8c4e842733d0b73.webp";